// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-cart-btn {\n  flex-direction: column;\n}", "",{"version":3,"sources":["webpack://./src/app/components/sale/cart/btn/cart-new-btn/cart-new-btn.component.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;AADJ","sourcesContent":["\r\n\r\n.page-cart-btn{\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
